<!-- lazy load component -->
@if (selector()) {
  <ng-container [appLazyDirective]="lazyConfig()" [inputs]="inputs()" [outputs]="outputs()" />
}
